import { rei } from "@/services/api"

class LivroService {
  static getConfigLivro (params) {
    return rei.get(`configuracao-livro/index`, { params })
  }

  static sendConfigLivro (params) {
    return rei.post(`configurar-livro`, params)
  }

  static getSequenLivro (params) {
    return rei.get(`sequencia-livro/index`, { params })
  }

  static sequenLivro (params) {
    return rei.post(`sequencia-livro`, params)
  }

  /* Importação em Lote */
  static getLivrosImportacaoEmLote (params) {
    return rei.get('importar-em-lote/livros',  { params: params }).then(res => res.data)
  }

  static getLivroById (livroId) {
    return rei.get(`importar-em-lote/livro/${livroId}`).then(res => res.data)
  }
}

export default LivroService
